<script setup lang="ts">
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'
import AppHeaderDropdownAccnt from '@/components/AppHeaderDropdownAccnt.vue'
import AppNotifications from '@/components/AppNotifications.vue'
import { IconMenu2, IconArrowBarToLeft, IconArrowBarToRight } from '@tabler/icons-vue'
import { ref, onMounted, onUnmounted } from 'vue'

const eventStore = useEventStore()
const { event } = storeToRefs(eventStore)

const useVisualConfig = useVisualConfigStore()
const { toggleSidebar } = useVisualConfig

const mobileMode = ref(window.innerWidth <= 768)

const handleResize = () => {
  mobileMode.value = window.innerWidth <= 768
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<template>
  <CHeader position="sticky" class="mb-3">
    <div class="right-header">
      <CHeaderNav class="me-1">
        <AppNotifications />
      </CHeaderNav>
      <CHeaderNav class="me-4">
        <AppHeaderDropdownAccnt />
      </CHeaderNav>
    </div>
    <div class="container-fluid">
      <CHeaderNav>
        <CNavItem>
          <div
            @click="toggleSidebar"
            style="padding-top: 26px; font-weight: 600; cursor: pointer"
            class="d-flex d-flex align-items-end"
          >
            <IconMenu2 v-if="mobileMode" class="me-2" />
            <h5 class="mb-0">
              {{ event.name }}
            </h5>
          </div>
        </CNavItem>
        <CHeaderToggler
          v-if="!mobileMode"
          style="padding-top: 18px; padding-left: 0; margin-top: -6px"
          :class="{ 'ms-4': event.name }"
          class="althead"
          @click="toggleSidebar"
        >
          <IconArrowBarToLeft
            v-if="useVisualConfig.sidebarVisible"
            style="margin-left: -3px; margin-top: 10px"
            stroke-width="1"
            size="24"
          />
          <IconArrowBarToRight v-else style="margin-left: -3px; margin-top: 10px" stroke-width="1" size="24" />
        </CHeaderToggler>
      </CHeaderNav>
    </div>
    <div style="height: 10px">&nbsp;</div>
    <div class="container-fluid">
      <AppBreadcrumb />
    </div>
  </CHeader>
</template>
